var map = {
	"./video-zowo.mp4": 800,
	"./video.mp4": 684,
	"./video0.mp4": 9958,
	"./video1.mp4": 8523,
	"./video2.mp4": 2692,
	"./video3.mp4": 9433,
	"./video4.mp4": 9506,
	"./video5.mp4": 6967,
	"./video6.mp4": 9168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1050;